// node_modules
import axios from "axios";
// Helpers
import { AxiosHelperSingleton } from "Helpers";

export class IntakeFunctionController {
    public async updateIntakeFunctionAsync(caseId: number, intakeFunctionId: number, 
            action: string, object: string, keyword: string): Promise<boolean> {
        const formData = new FormData();
        formData.append("IntakeFunctionID", `${intakeFunctionId}`);
        formData.append("Action", `${action}`);
        formData.append("Object", `${object}`);
        formData.append("Environment", `${keyword}`);
        formData.append("CaseID", `${caseId}`);
        const result = await axios.post(`${AxiosHelperSingleton.getServerBaseURL()}IntakeFunction/Edit/${intakeFunctionId}`,
            formData, { headers: { "Content-Type": "multipart/form-data" } });
        return result.status === 200;
    }

    public async createIntakeFunctionAsync(caseId: number): Promise<number | undefined> {
        const formData = new FormData();
        formData.append("CaseID", `${caseId}`);
        const result = await axios.post(`${AxiosHelperSingleton.getServerBaseURL()}IntakeFunction/Create`,
            formData, { headers: { "Content-Type": "multipart/form-data" } });
        if (result.status === 200) {
            return result.data.intakeFunctionID;
        } else {
            return undefined;
        }
    }

    public async deleteIntakeFunctionAsync(intakeFunctionId: number): Promise<boolean> {
        const formData = new FormData();
        const result = await axios.post(`${AxiosHelperSingleton.getServerBaseURL()}IntakeFunction/Delete/${intakeFunctionId}`,
        formData, { headers: { "Content-Type": "multipart/form-data" } });
        return result.status === 200;
    }
}

export const IntakeFunctionControllerSingleton = new IntakeFunctionController();